import { InvoiceItem } from "./invoice.item";

export enum LicenseStatus {

    Open = 0,
    Registered = 1,
    Cancelled = 2,
    CancelledOpen = 3,
    Disabled = 4,
    Terminated = 99,
    DoesNotExist = 100

}

export enum BillingRecurringTypes {

    Yearly = 2,
    Monthly = 1

}

export enum HoldStatusTypes {
    None = 0,
    Active = 1,
    LicenseResumed = 2,
    HoldFinished = 3
}

export interface IDashboardLicenseResponse {

    LicenseID: number;
    
    DateTimeCreated: Date;
    Key: string;
    SoftwareVersion: string;
    Status: LicenseStatus;    
    ProductName: string;
    ProductPrice : number;

    IsRegistered: boolean;    
    TerminationDate: Date;

    // Billing
    Recurring: BillingRecurringTypes;
    Price: number;
    IsGrace: boolean;
    GraceInvoice: InvoiceItem;

    NextBillingDate: Date;
    LastActiveDate : Date;

    //Hold
    IsOnHold: boolean;
    HoldStatus : HoldStatusTypes;
    HoldStartDate: Date;
    HoldEndDate: Date;
    IsScheduledHold: boolean;

    // YARD
    YardAvailable: boolean;
    HasYard: boolean;
    YardCancelled: boolean;
    
    

    // FixDates();

}


export class DashboardLicenseResponse implements IDashboardLicenseResponse {
    ProductPrice: number;
    LastActiveDate: Date;
    HoldStatus: HoldStatusTypes;

    LicenseID: number;
    Key: string;
    SoftwareVersion: string;
    Status: LicenseStatus;
    DateTimeCreated: Date;
    NextBillingDate: Date;
    Recurring: BillingRecurringTypes;
    Price: number;
    ProductName: string;
    YardAvailable: boolean;
    YardVisiblePublic: boolean;
    IsRegistered: boolean;
    HasYard: boolean;
    YardCancelled: boolean;
    TerminationDate: Date;
    IsGrace: boolean;
    GraceInvoice: InvoiceItem;

    IsOnHold: boolean;
    HoldStartDate: Date;
    HoldEndDate: Date;
    IsScheduledHold: boolean;


    // FixDates() {

        // this.DateTimeCreated = new Date(this.DateTimeCreated.toString() + "-08:00");
        // this.NextBillingDate = new Date(this.NextBillingDate.toString() + "-08:00");
        // this.TerminationDate = new Date(this.TerminationDate.toString() + "-08:00");
        // this.HoldStartDate = new Date(this.HoldStartDate.toString() + "-08:00");
        // this.HoldEndDate = new Date(this.HoldEndDate.toString() + "-08:00");
        // this.LastActiveDate = new Date(this.LastActiveDate.toString() + "-08:00");

        // this.DateTimeCreated = new Date(this.DateTimeCreated);
        // this.NextBillingDate = new Date(this.NextBillingDate);
        // this.TerminationDate = new Date(this.TerminationDate);
        // this.HoldStartDate = new Date(this.HoldStartDate);
        // this.HoldEndDate = new Date(this.HoldEndDate);
        // this.LastActiveDate = new Date(this.LastActiveDate);
    
    // }

}


export class DashboardLicenseResponseArray extends Array<DashboardLicenseResponse> {

    constructor(...items: DashboardLicenseResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, DashboardLicenseResponseArray.prototype);
    }

    public InitFromJSON() {

        if (this.length == 0)
            return;

        this.forEach((item) => {
            Object.setPrototypeOf(item, DashboardLicenseResponse.prototype);
            // item.FixDates();
        })
    }

}
